import { Component, Input } from '@angular/core';

@Component({
    selector: 'toggle',
    templateUrl: 'toggle.html',
    styleUrls: ['../field-abstract/icon-field.scss', 'toggle.scss']
})
export class ToggleComponent {}
